import React, { SVGProps } from 'react';

const UserGuideIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="UserGuideIcon">
    <path
      d="M15.5 14H3a.833.833 0 1 0 0 1.667h12.5v1.666H3a2.5 2.5 0 0 1-2.5-2.5v-12.5A1.667 1.667 0 0 1 2.167.667H15.5V14ZM2.167 12.375c.135-.027.274-.042.416-.042h11.25v-10H2.167v10.042ZM11.333 6.5H4.667V4.833h6.666V6.5Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default UserGuideIcon;
